import { createSlice } from '@reduxjs/toolkit';

const arrowGameSlice = createSlice({
  name: 'arrowGame',
  initialState: {
    stageId: null,
    themeName: null,
    byCategory: {},
  },
  reducers: {
    setArrowGameSession: (state, action) => {
      const p = action.payload || {};
      state.stageId = p.stageId != null ? Number(p.stageId) : null;
      state.themeName = p.themeName != null ? String(p.themeName) : null;
      if (p.byCategory && typeof p.byCategory === 'object') {
        state.byCategory = { ...p.byCategory };
      }
    },
    setArrowByCategory: (state, action) => {
      if (action.payload && typeof action.payload === 'object') {
        state.byCategory = { ...action.payload };
      }
    },
    clearArrowGameSession: (state) => {
      state.stageId = null;
      state.themeName = null;
      state.byCategory = {};
    },
  },
});

export const { setArrowGameSession, setArrowByCategory, clearArrowGameSession } = arrowGameSlice.actions;
export default arrowGameSlice.reducer;
